import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PivotViewComponent } from './pivotview.component';
/**
 * NgModule definition for the PivotView component.
 */
export class PivotViewModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        PivotViewComponent
    ],
    exports: [
        PivotViewComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PivotViewModule_tsickle_Closure_declarations() {
/** @type {?} */
PivotViewModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PivotViewModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
